import { Component, Input, ViewChild } from '@angular/core';
import { Editor } from 'primeng/editor';

@Component({
  selector: 's-ui-view-code',
  templateUrl: './s-ui-view-code.component.html',
  styleUrls: ['./s-ui-view-code.component.scss'],
  standalone: true,
  imports: [Editor]
})
export class SUiViewCodeComponent {
  @Input() value: string | unknown | undefined;
  @ViewChild('editor', { static: false }) editor: Editor | undefined;

  onLoaded() {
    if (this.editor) {
      this.editor.writeValue(this.value);
    }
  }

  ngOnChanges() {
    if (this.editor) {
      this.editor.writeValue(this.value);
    }
  }
}
